import { FileExcelOutlined, FileOutlined, FilePdfOutlined, FileWordOutlined } from '@ant-design/icons';
import { Card, Typography } from 'antd';
import React from 'react';
import { useFragment } from 'react-relay';
import styled from 'styled-components';

import { AttachmentFragment$key } from '../../graphql/__generated__/AttachmentFragment.graphql';
import { AttachmentFragment } from '../../graphql/fragments/AttachmentFragment';
import useAccessForAttachment from '../../hooks/useAccessForAttachment';
import { AttachmentType } from '../../types';
import DocumentViewerModal from '../DocumentViewerModal/DocumentViewerModal';
import AttachmentDeleteButton from './AttachmentDeleteButton';

const FixedWidthContainer = styled.div`
    width: 100px;
    margin: 8px;
    flex-shrink: 0;
`;

const StyledCard = styled(Card)`
    .remove-button {
        display: none;
    }
    &:hover .remove-button {
        display: block;
    }
`;

const CoverContainer = styled.div`
    height: 80px;
    display: flex !important;
    justify-content: center;
    align-items: center;
    background: #f0f2f5;
    position: relative;
`;

interface IAttachmentCard {
    attachment: AttachmentFragment$key;
    index: number;
    connectionId: string;
    model_id: string;
    model_type: string;
    accessToDelete: boolean;
}

const { Text } = Typography;

const AttachmentCard: React.FC<IAttachmentCard> = ({
    attachment,
    connectionId,
    model_id,
    model_type,
    accessToDelete,
}) => {
    const attachmentData = useFragment<AttachmentFragment$key>(AttachmentFragment, attachment);
    const [isModalVisible, setIsModalVisible] = React.useState(false);

    const accessToDeleteOwnAttachment = useAccessForAttachment(attachmentData as AttachmentType, [
        'schedule-task.assignee.manage',
    ]);

    console.log('>>>>', attachmentData.created_by);
    const getFileIcon = (extension: string) => {
        switch (extension.toLowerCase()) {
            case 'pdf':
                return <FilePdfOutlined style={{ fontSize: 40 }} />;
            case 'doc':
            case 'docx':
                return <FileWordOutlined style={{ fontSize: 40 }} />;
            case 'xls':
            case 'xlsx':
                return <FileExcelOutlined style={{ fontSize: 40 }} />;
            default:
                return <FileOutlined style={{ fontSize: 40 }} />;
        }
    };

    const isImage = (extension: string) => {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
        return imageExtensions.includes(extension.toLowerCase());
    };

    const handleCardClick = () => {
        const canPreview = attachmentData.extension.toLowerCase() === 'pdf' || isImage(attachmentData.extension);

        if (canPreview) {
            setIsModalVisible(true);
        } else {
            window.open(attachmentData.url, '_blank');
        }
    };

    return (
        <>
            {/* <Draggable key={attachmentData.id} draggableId={attachmentData.id} index={index}> */}
            {/* {(provided, snapshot) => ( */}
            <FixedWidthContainer
            // ref={provided.innerRef}
            // {...provided.draggableProps}
            // {...provided.dragHandleProps}
            // style={{
            //     ...provided.draggableProps.style,
            //     opacity: snapshot.isDragging ? 0.5 : 1
            // }}
            >
                <StyledCard
                    hoverable
                    cover={
                        <CoverContainer>
                            {isImage(attachmentData.extension) ? (
                                <img
                                    src={attachmentData.url}
                                    alt={attachmentData.name}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            ) : (
                                getFileIcon(attachmentData.extension)
                            )}
                            {(accessToDelete || accessToDeleteOwnAttachment) && (
                                <AttachmentDeleteButton
                                    attachment={attachmentData}
                                    connectionId={connectionId}
                                    model_id={model_id}
                                    model_type={model_type}
                                />
                            )}
                        </CoverContainer>
                    }
                    styles={{
                        body: { padding: '6px', textAlign: 'center' },
                    }}
                    onClick={handleCardClick}
                >
                    <Text ellipsis={{ tooltip: attachmentData.name }} style={{ fontSize: '10px' }}>
                        {attachmentData.name}
                    </Text>
                </StyledCard>
            </FixedWidthContainer>
            {/* )} */}
            {/* </Draggable> */}

            <DocumentViewerModal
                open={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                document={{
                    id: attachmentData.id,
                    name: attachmentData.name,
                    url: attachmentData.url,
                    extension: attachmentData.extension,
                }}
            />
        </>
    );
};

export default AttachmentCard;
